export const UPLOADING_SHOW = 'contentManagement/UPLOADING_SHOW'
export const UPLOADING_HIDE = 'contentManagement/UPLOADING_HIDE';
export const SET_COUNT = 'contentManagement/SET_COUNT';
export const SET_LIST = 'contentManagement/SET_LIST';
export const REFRESH_CURRENT = 'contentManagement/REFRESH_CURRENT';
export const VALUES = 'contentManagement/VALUES';
export const CURRENTS = 'contentManagement/CURRENTS';
export const COMPILE_SHOW = 'contentManagement/COMPILE_SHOW';
export const COMPILE_HIDE = 'contentManagement/COMPILE_HIDE';
export const CONTENT = 'contentManagement/CONTENT';